import React from "react";
import { Paper } from '@material-ui/core';
import {
  TableCell,
  TableHead,
  TableRow,
  Table,
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const selectDate = this.props.selectDate;
    const inactiveCustomerData = this.props.inactiveCustomerData;

    const cellStyle = {
      border: '1px solid black',
      padding: '2px 6px',
      fontSize: '0.9rem',
    };

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div>
          <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
            <br />
            <h2><center>Inactive Customer Report</center></h2>
            <div>&nbsp;</div>
            <h3><center>{searchData.groupName}</center></h3>
            <div>&nbsp;</div>
            <h3><center>{searchData.factoryName}</center></h3>
            <div>&nbsp;</div>
            <h3><center>{searchData.routeName ? searchData.routeName : "All Routes"}</center></h3>
            <div>&nbsp;</div>
            <h3><center>{moment(selectDate).format('MMMM')} - {searchData.year}</center></h3>
            <div>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow style={{ border: "2px solid black" }}>
                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Route</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Registration Number</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Customer Name</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Last Supply Month</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%' }}>Balance(Rs)</TableCell>
                  </TableRow>
                </TableHead>
                {inactiveCustomerData.map((row, i) => (
                  <TableRow style={{ border: "2px solid black" }} key={i}>
                    <TableCell component="th" scope="row" align="left" style={cellStyle}> {row.routeName}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={cellStyle}> {row.registrationNumber}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={cellStyle}> {row.name}</TableCell>
                    <TableCell component="th" scope="row" align="center" style={cellStyle}> {parseInt(moment(row.lastSupplyMonth).format('YYYY')) == 1 ? '-' : moment(row.lastSupplyMonth).format('MMMM YYYY')}</TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black", width: '20%' }}>
                      {(row.paymentStatus === true ? row.currentBalance : row.currentBalanceBeaforeBPRun).toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell align="left" style={{ fontWeight: "bold", border: "2px solid black", fontSize: '16px', width: '20%', color: 'red' }}>Total </TableCell>
                  <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}></TableCell>
                  <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black", width: '20%' }}></TableCell>
                  <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black", width: '20%' }}></TableCell>
                  <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black", width: '20%' }}>{inactiveCustomerData.reduce((sum, row) => sum + (row.paymentStatus === true ? row.currentBalance : row.currentBalanceBeaforeBPRun), 0).toLocaleString()}</TableCell>
                </TableRow>
              </Table>
            </div>
            <div>&nbsp;</div>
            <h4><center>*******End of List*******</center></h4>
          </div></div>
      </Paper>
    );
  }
}